import { j as json } from "../../../../../../chunks/index2.js";
import admin from "firebase-admin";
const GET = async ({ cookies }) => {
  const sessionId = cookies.get("session_id");
  if (sessionId) {
    cookies.delete("session_id", { path: "/", httpOnly: true, secure: true });
    await admin.firestore().collection("sessions").doc(sessionId).delete();
  }
  return json({
    success: true
  });
};
export {
  GET
};
